import { MathUtils } from 'three';
import { EventHub } from './event-hub';
import { ForgeViewerEvents } from './forge-viewer.enums';
import { normaliseAngle } from './forge-viewer.utils';

export class CameraController {
    private viewer: Autodesk.Viewing.GuiViewer3D;

    constructor(viewer: Autodesk.Viewing.GuiViewer3D) {
        this.viewer = viewer;
    }

    //    private setView(position: THREE.Vector3, target?: THREE.Vector3) {
    //         const nav = this.viewer.navigation;
    //         const currentTarget = nav.getTarget().clone();
    //         const targetToUse = target ?? currentTarget;
    //         nav.setView(position, targetToUse);
    //     }

    setPosition(position: THREE.Vector3) {
        const nav = this.viewer.navigation;
        const camera = this.viewer.getCamera();

        // Save original direction vector
        const originalTarget = nav.getTarget().clone();
        const originalPosition = camera.position.clone();
        const direction = originalTarget.sub(originalPosition).normalize();

        // Compute new target from original direction
        const newTarget = position.clone().add(direction);

        // Preserve up vector
        const up = camera.up.clone();

        // Apply camera transform
        nav.setView(position, newTarget);

        // Restore up vector to avoid tilt / roll changes
        camera.up.copy(up);

        // Required to apply changes
        this.viewer.impl.sceneUpdated(true);
    }

    setDirection(direction: THREE.Vector3) {
        // Get model bounds
        const bounds = this.viewer.model.getBoundingBox();
        const center = bounds.getCenter();
        const size = bounds.getSize();
        const distance = Math.max(size.x, size.y, size.z) * 2;

        // Camera at (center.x, center.y - distance, center.z)
        // Looking toward (center.x, center.y + something, center.z)
        this.viewer.navigation.setPosition(new THREE.Vector3(center.x, center.y - distance, center.z));
        this.viewer.navigation.setTarget(center);
        this.viewer.navigation.setCameraUpVector(direction);
    }

    restoreState(state: any) {
        this.viewer.restoreState(state, null, true);
    }

    getState(filter?: any) {
        return this.viewer.getState(filter);
    }

    setCurrentViewAsHome() {
        this.viewer.autocam.setCurrentViewAsHome();
    }
    // setHome(options: {
    //     position?: THREE.Vector3;
    //     direction?: THREE.Vector3;
    //     rotation?: { yaw: number; pitch: number };
    //     fov?: number;
    // }) {
    //     const { position, direction, rotation, fov } = options;

    //     if (direction) this.setDirection(direction);

    //     if (position) this.setPosition(position);

    //     // if (fov) this.setFOV(fov);

    //     // if (rotation) this.setRotation(rotation);

    //     // this.viewer.autocam.setCurrentViewAsHome();
    // }

    // animateToPosition(position: THREE.Vector3, duration = 1000) {
    //     const nav = this.viewer.navigation;
    //     const camera = this.viewer.getCamera();

    //     const startPos = camera.position.clone();
    //     const originalTarget = nav.getTarget().clone();
    //     const direction = originalTarget.clone().sub(startPos).normalize();

    //     const targetPos = position.clone();
    //     const targetLook = targetPos.clone().add(direction);

    //     const up = camera.up.clone();

    //     const startTime = performance.now();

    //     const animate = (time: number) => {
    //         const t = Math.min((time - startTime) / duration, 1);

    //         // Smoothstep easing (nicer than linear)
    //         const s = t * t * (3 - 2 * t);

    //         const currentPos = startPos.clone().lerp(targetPos, s);
    //         const currentTarget = originalTarget.clone().lerp(targetLook, s);

    //         nav.setView(currentPos, currentTarget);
    //         camera.up.copy(up);

    //         this.viewer.impl.sceneUpdated(true);

    //         if (t < 1) {
    //             requestAnimationFrame(animate);
    //         }
    //     };

    //     requestAnimationFrame(animate);
    // }

    // getRotation() {
    //     const nav = this.viewer.navigation;

    //     const position = nav.getPosition().clone();
    //     const target = nav.getTarget().clone();

    //     const dir = target.clone().sub(position).normalize();

    //     // dir.x = sin(yaw) * cos(pitch)
    //     // dir.y = cos(yaw) * cos(pitch)
    //     // dir.z = sin(pitch)

    //     // ---- PITCH ----
    //     const pitchRad = Math.asin(dir.z);
    //     const pitch = MathUtils.radToDeg(pitchRad);

    //     // ---- YAW ----
    //     // atan2(x, y) since you defined:
    //     // x = sin(yaw)*cos(pitch)
    //     // y = cos(yaw)*cos(pitch)
    //     const yawRad = Math.atan2(dir.x, dir.y);
    //     let yaw = MathUtils.radToDeg(yawRad);

    //     // normalize 0–360
    //     yaw = MathUtils.euclideanModulo(yaw, 360);

    //     // Return rotation relative to default values
    //     return {
    //         yaw: normaliseAngle(yaw) - this.defaultYaw,
    //         pitch: pitch - this.defaultPitch,
    //     };
    // }

    // setRotation(values: { yaw: number; pitch: number }) {
    //     let { yaw, pitch } = values;

    //     // Apply rotation relative to default values
    //     pitch = this.defaultPitch + pitch;
    //     yaw = this.defaultYaw + yaw;

    //     pitch = Math.max(-85, Math.min(85, pitch));
    //     yaw = normaliseAngle(yaw); // stays 0–360

    //     const nav = this.viewer.navigation;
    //     const position = nav.getPosition().clone();
    //     const currentTarget = nav.getTarget().clone();

    //     const radius = position.distanceTo(currentTarget);

    //     const yawRad = MathUtils.degToRad(yaw);
    //     const pitchRad = MathUtils.degToRad(pitch);

    //     const dir = new THREE.Vector3(
    //         Math.sin(yawRad) * Math.cos(pitchRad), // X
    //         Math.cos(yawRad) * Math.cos(pitchRad), // Y
    //         Math.sin(pitchRad) // Z
    //     )
    //         .normalize()
    //         .multiplyScalar(radius);

    //     const target = position.clone().add(dir);

    //     nav.setView(position, target);

    //     this.viewer.impl.sceneUpdated(true);

    //     // Emit relative values (without defaults) so listeners get consistent values
    //     this.eventHub.emit(ForgeViewerEvents.PAN_CHANGE, {
    //         pitch: pitch - this.defaultPitch,
    //         yaw: normaliseAngle(yaw) - this.defaultYaw,
    //     });
    //     // this._onRotationChange?.({ pitch, yaw });
    // }

    // getPan() {
    //     return this.getRotation();
    // }

    // setPan(values: { yaw: number; pitch: number }) {
    //     this.setRotation(values);
    // }

    // setPositionPreserveDirection(position: THREE.Vector3) {
    //     const camera = this.viewer.getCamera();
    //     const dir = camera.getWorldDirection(new THREE.Vector3());
    //     const target = position.clone().add(dir);
    //     this.viewer.navigation.setView(position, target);
    // }

    // lookAt(point: THREE.Vector3) {
    //     const camera = this.viewer.getCamera();
    //     camera.lookAt(point);
    //     this.viewer.impl.sceneUpdated(true);
    // }
}
